// extracted by mini-css-extract-plugin
export default {"title":"Products_title__HCti8","description":"Products_description__Vq0oa","card":"Products_card__gFcrW","cardTitle":"Products_cardTitle__qe8+n"};